module.exports = __webpack_public_path__ + "img/00634453001141.d25fe53d.png";